module.exports = __webpack_public_path__ + "img/gray-enabing-skills.06ffd075.png";